import type { Rule, RuleObject } from 'antd/es/form';

// ИДЕНТИФИКАТОРЫ
export const ERROR = 'error';
export const WARNING = 'warning';
export const INFO = 'info';
export const SUCCESS = 'success';
export const SYSTEM_USER_ID = 1;

// Используется для отделения фронтовых багов от серверных. Вместо привычного двоеточия используются скобки,
// т.к. в некоторых фронтовых ошибках встречались случаи использования двоеточий, напр., для перечислений
export const FRONT_ERROR_PREFIX = '(FE) ';
export const FRONT_WARNING = 'frontWarning';

// ТЕКСТЫ

// Успешные операции
export const DATA_UPDATED_SUCCESSFULLY = 'Данные обновлены успешно';

// Ошибки
export const DEFAULT_WARNING = 'Что-то пошло не так';
export const USER_PRINT_ERROR = 'При загрузке пользователя произошла ошибка';
export const ERROR_404_NOT_FOUND =
  'К сожалению, эта страница не найдена. ' +
  'Возможно, она была удалена или перемещена по другой ссылке. ' +
  'Пожалуйста, попробуйте найти её через меню сайта.';
export const ERROR_REQUIRED_FIELD = 'Обязательное поле';
export const ERROR_INVALID_EMAIL = 'Email указан неверно';
export const ERROR_INVALID_PHONE = 'Телефонный номер указан неверно';
export const DEFAULT_ERROR_MESSAGE = 'Непредвиденная ошибка';
export const DEFAULT_ERROR_DESCRIPTION =
  'Повторите попытку позже или обратитесь к администратору';
export const ERROR_INVALID_PHONE_SHORT = 'Телефон указан неверно';
export const SUCCESS_MESSAGE = 'Данные успешно сохранены';
export const NO_SPACE = 'Использование пробелов запрещено';
export const MIN_SIX_SYMBOLS = 'Минимум - 6 символов';
export const LETTER_NECESSARY = 'Обязательное наличие буквы';
export const UPPERCASE_LETTER_NECESSARY =
  'Обязательное наличие заглавной буквы';
export const NUMBER_NECESSARY = 'Обязательное наличие цифры';
export const MIN_THREE_SYMBOLS = 'Минимум - 3 символа';
export const MIN_TWO_SYMBOLS = 'Минимум - 2 символа';
export const MIN_ONE_SYMBOLS = 'Минимум - 1 символ';
export const MIN_THIRTY_SIX_SYMBOLS = 'Минимум - 36 символов';
export const ERROR_INVALID_END_TIME =
  'Время окончания должно быть позже времени начала.';
export const ERROR_SERVICES_COUNT = 'Неверное кол-во услуг.';
export const MIN_DURATION = 'Минимальное время: 15 минут';
export const NUMBERS_ONLY = 'Поле принимает только числовые значения';
export const LETTERS_AND_NUMBERS_ONLY = 'Поле принимает только буквы и цифры';
export const MAX_LENGTH_MESSAGE = 'Превышено максимальное количество символов';

export const EMAIL_TYPE_VALIDATION: Rule = {
  type: 'email',
  message: <span data-testid="email-alert">Неправильный формат email!</span>,
};
export const EMAIL_LENGTH_VALIDATION: Rule = {
  min: 5,
  max: 100,
  message: (
    <span data-testid="email-alert">
      Email должен быть от 5 до 100 символов!
    </span>
  ),
};
export const EMPTY_INPUT_VALUE_VALIDATOR = {
  validator: (_: RuleObject, value: string) =>
    value && value.trim()
      ? Promise.resolve()
      : Promise.reject(new Error('Поле не может содержать только пробелы')),
};
